import React, { useState } from 'react'
import { DeviceModeSelect } from 'src/editor/layout/sidebar/settings/device-mode-select'
import { Switcher } from 'src/editor/shared/ui-lib/switcher'
import { WebsiteLanguageSwitcherInterface } from 'src/shared/types/entities/website-language-switcher-interface'
import { WebsiteLanguageSwitcherSettingsDesign } from './website-language-switcher-settings-design'
import { WebsiteLanguageSwitcherSettingsLanguages } from './website-language-switcher-settings-languages'

export interface WebsiteLanguageSwitcherSettingsProps {
  entity: WebsiteLanguageSwitcherInterface
}

const sidebarModes = {
  language: 'language',
  design: 'design',
} as const
type SidebarMode = keyof typeof sidebarModes

export const WebsiteLanguageSwitcherSettings = ({
  entity,
}: WebsiteLanguageSwitcherSettingsProps) => {
  const [mode, setMode] = useState<SidebarMode>(sidebarModes.language)
  return (
    <div className="mt-[-20px]">
      {mode === sidebarModes.design && <DeviceModeSelect />}

      <Switcher
        btnList={[
          {
            value: sidebarModes.language,
            content: 'components.core.toolbox.types.language',
          },
          {
            value: sidebarModes.design,
            content: 'components.core.toolbox.types.design',
          },
        ]}
        value={mode}
        update={setMode}
        wrapperClassName="p-0 mb-5"
      />

      {mode === sidebarModes.language ? (
        <WebsiteLanguageSwitcherSettingsLanguages entity={entity} />
      ) : (
        <WebsiteLanguageSwitcherSettingsDesign entity={entity} />
      )}
    </div>
  )
}
